import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-sel",
  "use": "vab-icon-sel-usage",
  "viewBox": "0 0 15 12",
  "content": "<symbol viewBox=\"0 0 15 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-sel\">\n<path d=\"M12.75 3.75H14.25V9.75C14.25 10.575 13.575 11.25 12.75 11.25H2.25C1.425 11.25 0.75 10.575 0.75 9.75V2.25C0.75 1.425 1.425 0.75 2.25 0.75H11.25V2.25H2.25V9.75H12.75V3.75ZM11.25 3.75H3.75V5.25H11.25V3.75ZM9.75 6.75H3.75V8.25H9.75V6.75ZM12.75 2.25H14.25V0.75H12.75V2.25Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol